import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/api/axios';
import { useAuditStore } from '@/store/auditStore';

type GenerateReportParams = {
  auditCaseId: string;
  language: string;
  moduleId: string;
};

const generateReport = async ({
  auditCaseId,
  language,
  moduleId,
}: GenerateReportParams): Promise<ArrayBuffer> => {
  const { data } = await api.get(`/audit-cases/${auditCaseId}/report`, {
    params: {
      language,
      moduleId,
    },
    responseType: 'arraybuffer',
  });
  return data;
};

export const useGenerateReport = ({
  auditCaseId,
  language,
  moduleId,
}: {
  auditCaseId: string;
  language: string;
  moduleId: string;
}): UseQueryResult<ArrayBuffer, unknown> => {
  const audit = useAuditStore((state) => state.audit)!;

  return useQuery({
    queryKey: ['report', auditCaseId, language, moduleId, audit.toIfsFile().hash],
    queryFn: () => generateReport({ auditCaseId, language, moduleId }),
    enabled: false,
  });
};
